import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { FiAlignRight, FiXCircle, FiChevronDown } from "react-icons/fi";
import "./HomeNavbarmenu.css";
import { useMsal } from "@azure/msal-react";
const HomeNavbarmenu = () => {
  const [isMenu, setisMenu] = useState(false);
  const [isResponsiveclose, setResponsiveclose] = useState(false);
  const toggleClass = () => {
    setisMenu(isMenu === false ? true : false);
    setResponsiveclose(isResponsiveclose === false ? true : false);
  };
  let boxClass = ["main-menu"];
  if (isMenu) {
    boxClass.push("menuq2");
  } else {
    boxClass.push("");
  }
  const hide = () => setisMenu(false);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  let loggedInEnterpriseId = "";
  if (activeAccount)
    loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;

  const [isMenuSubMenu, setMenuSubMenu] = useState(false);
  const toggleSubmenu = () => {
    setMenuSubMenu(isMenuSubMenu === false ? true : false);
  };
  let boxClassSubMenu = ["sub__menus"];
  if (isMenuSubMenu) {
    boxClassSubMenu.push("sub__menus__Active");
  } else {
    boxClassSubMenu.push("");
  }

  return (
    <header className="header__middle">
      <div className="head-container">
        <div className="row">
          <div className="header__middle__menus">
            <nav className="main-nav ">
              {/* Responsive Menu Button */}
              {isResponsiveclose === true ? (
                <>
                  <span
                    role="button"
                    tabIndex={0}
                    aria-haspopup="true"
                    aria-expanded="false"
                    type="button"
                    className="menubar__button"
                    style={{ display: "none" }}
                    onClick={toggleClass}
                  >
                    {" "}
                    <FiXCircle />{" "}
                  </span>
                </>
              ) : (
                <>
                  <span
                    role="button"
                    tabIndex={0}
                    aria-haspopup="true"
                    aria-expanded="false"
                    type="button"
                    className="menubar__button"
                    style={{ display: "none" }}
                    onClick={toggleClass}
                  >
                    {" "}
                    <FiAlignRight />{" "}
                  </span>
                </>
              )}
              <ul className={boxClass.join(" ")}>
                <li className="menu-item">
                  <NavLink
                    to="/Home"
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    exact
                  >
                    <span>
                      L&TT <br /> Home
                    </span>
                    {/* <img
                      src="images/Home/home-active-icon.png"
                      alt="home"
                      className="hovering-home"
                    /> */}
                  </NavLink>
                </li>
                <li className="menu-item">
                  <NavLink
                    to="/Academies-Tracks"
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    exact
                  >
                    <span>
                      Academies <br /> & Tracks
                    </span>
                  </NavLink>
                </li>
                <li className="menu-item">
                  <NavLink
                    to="/AI-Academy"
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    exact
                  >
                    <span>
                      AI <br /> Academy
                    </span>
                  </NavLink>
                </li>
                <li className="menu-item">
                  <NavLink
                    to="/Role-Aligned-Curriculum"
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    exact
                  >
                    <span>
                      Role-Aligned <br /> Curriculum
                    </span>
                  </NavLink>
                </li>
                <li className="menu-item">
                  <NavLink
                    to="/Learning-Calendar"
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    exact
                  >
                    <span>
                      Learning <br /> Calendar
                    </span>
                  </NavLink>
                </li>
                <li className="menu-item">
                  <NavLink
                    to="/Programs-Certifications"
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    exact
                  >
                    {" "}
                    <span>
                      Programs <br /> & Certifications
                    </span>
                  </NavLink>
                </li>
                <li className="menu-item">
                  <NavLink
                    to="/LTT-Podcast"
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    exact
                  >
                    <span>
                      L&TT <br /> Podcast
                    </span>
                  </NavLink>
                </li>
                <li className="menu-item">
                  <a
                    href="https://mml.accenture.com/home"
                    activeClassName="is-active"
                    className="nav-links"
                    target="_blank"
                    onClick={toggleClass}
                    exact
                  >
                    <span>
                      Learners <br /> Feedback
                    </span>
                  </a>
                </li>

                {/* <li className="menu-item">
                  <NavLink
                    to="/About-LTT"
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    exact
                  >
                    <span>
                      About <br /> L&TT
                    </span>
                  </NavLink>
                </li> */}

                <li
                  className="menu-item menu-item-has-children"
                  onMouseEnter={() => setMenuSubMenu(true)}
                  onMouseLeave={() => setMenuSubMenu(false)}
                >
                  <NavLink
                    to="/About-LTT"
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    exact
                    aria-expanded="false"
                    aria-haspopup="true"
                  >
                    <span>
                      About <br /> L&TT <FiChevronDown />
                    </span>
                  </NavLink>
                  <ul className={boxClassSubMenu.join(" ")}>
                    <li>
                      <a
                        href="/About-LTT#Our-Expertise"
                        className="sub-nav-link"
                        activeClassName="is-active"
                        onClick={toggleClass}
                      >
                        Our Expertise
                      </a>
                    </li>
                    <li>
                      <a
                        href="/About-LTT#Our-Leads"
                        className="sub-nav-link"
                        activeClassName="is-active"
                        onClick={toggleClass}
                      >
                        Our Leads
                      </a>
                    </li>
                    <li>
                      <a
                        href="/About-LTT#Awards"
                        className="sub-nav-link"
                        activeClassName="is-active"
                        onClick={toggleClass}
                      >
                        Awards
                      </a>
                    </li>
                  </ul>
                </li>

                {/* {allowedUsers.includes(loggedInEnterpriseId) && (
                  <li className="menu-item">
                    <NavLink
                      to="/Reviews"
                      activeClassName="is-active"
                      className="nav-links"
                      onClick={toggleClass}
                      exact
                    >
                      <span>
                        Admin <br /> Feedback
                      </span>
                    </NavLink>
                  </li>
                )} */}
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default HomeNavbarmenu;
